import axios from 'axios';
import {Toast} from 'antd-mobile';
import qs from 'qs';
const queryString = require('query-string');
axios.defaults.headers['Content-Type'] = 'application/json';


let requestURL = '';
if (process.env.NODE_ENV === 'production') {
    requestURL = 'https://timefilter.aishiguang.net/client-api';
}
if (process.env.NODE_ENV === 'development') {
    requestURL = 'https://timefilter-dev.aishiguang.net/client-api';
}


export default function request(url, params) {
    const configParam = {
        url,
        method:'post',
        baseURL:requestURL,
        headers:{
          'Content-Type':'application/x-www-form-urlencoded'
        }
    };
    if (window.XUserSession) {
      configParam.headers['X-User-Session'] = window.XUserSession
    }

    configParam.data = qs.stringify(params);
    
    return new Promise((resovle, reject) => {
        axios(configParam)
            .then(res => {
                const resData = res.data;
                if (resData.status === 1) {
                    resovle(resData.data);
                } else if (resData.status === 2) {
                    if (resData.data) {
                        // window.location.href = resData.data.redirectUrl;
                        window.location.replace(resData.data.redirectUrl)
                    }
                } else if (resData.status === 11) {
                    resData.data = { isDelete: true, list: resData.data };
                    resovle(resData.data);
                } else if (resData.status === -999) {
                    let params = {
                        // redirectUrl: encodeURIComponent(window.location.href),
                        redirectUrl: window.location.href,
                        appCode: queryString.parse(window.location.href.split('?')[1]).appCode,
                        debugEnable: true
                    };
                    axios({
                        method: 'post',
                        url: `${requestURL}/wechat-user/login-info`,
                        data: qs.stringify(params),
                        headers:{
                          'Content-Type':'application/x-www-form-urlencoded'
                        }
                    }).then(res => {
                        if (res.data.status === -999) {
                            window.location.replace(res.data.data.redirectUrl)
                            // window.location.href = res.data.data.redirectUrl;
                        } else {
                            Toast.info(resData.msg || '登录出错')
                        }
                    });
                } else {
                    Toast.info(resData.msg || '请求出错')
                    reject(resData);
                }
            })
            .catch(err => {
                Toast.info('请求出错')
                reject(err);
            });
    });
}